<template>
	<div class="myfavors">
		<MatchList :list="matchList" @infiniteHandler="infiniteHandler"></MatchList>
        <infinite-loading @infinite="infiniteHandler"></infinite-loading>
	</div>
        <!--  -->

</template>

<script>
	import './myfavors.less'
    import MatchList from '@/components/matchList'
    import {myfavors} from '@/libs/api'
    import {setStorage, getStorage,formatTime} from '@/libs/utils'
    export default {
        name: 'myfavors',
        data() {
            return {
                matchList: [],
                urid: '',
                token: '',
                page: 1,
                limit: 20
            }
        },
        components: {
            MatchList
        },
        methods: {
        	infiniteHandler:function($state){
                // this.handleSpinShow(true);
                myfavors({page:this.page,limit:this.limit,token:this.token,urid:this.urid}).then((res) => {
                    if (res.status== 200) {
                        if(res.data.list.length>0){
                            this.page+=1;
                            this.matchList.push(...res.data.list)
                            $state.loaded()
                            if(res.data.list.length<20){
                                $state.complete()
                            }
                        }else{
                            $state.complete()
                        }

                    }
                    // this.handleSpinShow(false);
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
            	let userinfo = getStorage('userInfo')
                this.urid = userinfo.urid
		        this.token = userinfo.token
            })
        }
    }
</script>